import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useGetCommunityStats } from '@onesource/services';
import type { FC } from 'react';

import { CommunityStatsWidgetSkeleton } from './community-stats-widget-skeleton';
import { WidgetCard, WidgetEmpty } from './widget-card';

interface CommunityStatsWidgetProps {
  spaceId: string;
}

const StatRow: FC<{ label: string; value: number | undefined }> = ({ label, value }) => (
  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
    <Typography sx={{ fontFamily: 'Figtree, sans-serif', fontSize: 13, color: '#666' }}>{label}</Typography>
    <Typography sx={{ fontFamily: 'Figtree, sans-serif', fontSize: 14, fontWeight: 700, color: '#1a1a2e' }}>
      {(value ?? 0).toLocaleString()}
    </Typography>
  </Box>
);

/** Total members of the space's app + posts created in the current calendar month. */
export const CommunityStatsWidget: FC<CommunityStatsWidgetProps> = ({ spaceId }) => {
  const { data, isLoading } = useGetCommunityStats(spaceId);

  if (isLoading) {
    return <CommunityStatsWidgetSkeleton />;
  }

  if (!data) {
    return (
      <WidgetCard title="Community Stats">
        <WidgetEmpty>Stats aren’t available yet.</WidgetEmpty>
      </WidgetCard>
    );
  }

  return (
    <WidgetCard title="Community Stats">
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <StatRow label="Total members" value={data.totalMembers} />
        <StatRow label="Posts this month" value={data.postsThisMonth} />
      </Box>
    </WidgetCard>
  );
};
